import { getToken } from "commonFunctions/getToken";
import client from "utils/API/interceptor";
import * as c from "utils/constants/constants";
import { getQueryFilters } from "./helper";
import api from "utils/API/api";

export async function getDocumentDetailData(doc_id) {
    try {
        const token = await getToken();
        const url = `${c.ROOT_URL}/getDoc/${doc_id}?comp=${c.UI_COMP.document}&action=${c.UI_ACTION.Document_viewed}`;
        const { data } = await client.get(url, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return data.data[0];
    } catch (err) {
        console.error("getDocumentDetailData error ➜", err);
        throw err;
    }
}

export async function getDocumentDetailDataAfterUpdate(doc_id) {
    try {
        const token = await getToken();
        const url = `${c.ROOT_URL}/getDoc/${doc_id}`;
        const { data } = await client.get(url, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return data.data[0];
    } catch (err) {
        console.error("getDocumentDetailData error ➜", err);
        throw err;
    }
}

export async function getDocumentPreviewUrl(doc_id) {
    try {
        const token = await getToken();
        const url = `${c.ROOT_URL}/getDocFileSignedUrl/${doc_id}`;
        const { data } = await client.get(url, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return data.data[0];
    } catch (err) {
        console.error("getDocumentDetailData error ➜", err);
        throw err;
    }
}

export async function getClassificationMappingData() {
    try {
        const token = await getToken();
        const url = `${c.ROOT_URL}/getDocClassificationMapping`;
        const { data } = await client.get(url, {
            headers: { Authorization: `Bearer ${token}` }
        });
        return data.data[0];
    } catch (err) {
        throw err;
    }
}

export async function getDocumentId(step) {
    let query = getQueryFilters();
    const Params = new URLSearchParams(window.location.search);
    let doc_id = Params.get('doc_id');

    if (query) {
        return await api.get_doc_id(query, doc_id, step)
            .then((response) => {
                if (response.status == 200) {
                    return response.data.data;
                }
            })
            .catch(error => {
                throw error;
            })
    }
}

export async function exitDocument(docId) {
    return api.exit_doc_details(docId, {
        "Is_Active": false
    })
        .then((response) => response)
}

export async function uploadToOnbase(query, comp, action) {
    return api.upload_to_onbase(query, comp, action).then((response) => {
        if (response.status === 200) {
            return response.data
        }
    }).catch((error) => {
        throw error
    });
}

export async function moveToCompleteStatus(query, comp, action) {
    return api.complete_document(query, comp, action).then((response) => {
        if (response.status === 200) {
            return response.data
        }
    }).catch((error) => {
        throw error
    });
}

export async function moveToMarkedAsComplete(query, comp, action) {
    return api.skip_upload(query, comp, action).then((response) => {
        if (response.status === 200) {
            return response.data
        }
    }).catch((error) => {
        throw error
    });
}

export async function saveData(data, docId, revisionId, str) {
    const comp = c.UI_COMP.document.toString();
    const action = c.UI_ACTION.Document_updated;
    return api
        .update_after_review(
            data,
            docId,
            revisionId,
            comp,
            action,
            str
        )
        .then((response) => response ).catch((error) => {
            throw error;
        });
}




